import AccountBase from '@components/common/auth/account/AccountBase';
import BioEditor from '@components/common/auth/account/BioEditor';
import PhotoEditor from '@components/common/auth/account/PhotoEditor';
import React from 'react';

const InstructorAccount: React.FC = () => {
  return (
    <AccountBase>
      <PhotoEditor></PhotoEditor>
      <BioEditor></BioEditor>
    </AccountBase>
  );
};

export default InstructorAccount;
